import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import LiteratureCoverLetter from '../../_partials/HtmlLiteratureCoverLetter';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
const LiteratureMonoHtmlView = (props)=>{
    const { deviation , config: { link  }  } = props;
    return /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation,
        linkClass: "gallery-link"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('daeditor-literature-root', getThumbGlobalClassNames(deviation), props.config && props.config.alignment && `daeditor-align-${props.config.alignment}`, props.settings && props.settings.showMediaAlwaysSmall && `daeditor-small`)
    }, /*#__PURE__*/ React.createElement(LiteratureCoverLetter, _extends({}, props)), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-literature-title"
    }, getDeviationTitle(deviation)), /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-literature-text"
    }, deviation.textContent && deviation.textContent.excerpt))));
};
LiteratureMonoHtmlView.displayName = 'LiteratureMonoHtmlView';
export default LiteratureMonoHtmlView;
